import { useEffect, useState } from 'react';
import css from './index.module.scss';
import EfLink from '@elem/ui/ef-link';
import { useLang } from '@/i18n';

const FP: React.FC = () => {
    const INIT_PROCESS: number = 100;
    const { t } = useLang('Oasis');
    const [enter, setEnter] = useState<boolean>(false);
    const [active, setActive] = useState<number>(0);
    const [process, setProcess] = useState<number>(INIT_PROCESS);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const sceneEnter = AniContainer.create({
                triggerElement: '.page-oasis .range1',
                triggerHook: 1,
                offset: 0,
                duration: '3000%',
                onEnter: () => setEnter(true),
                onLeave: () => setEnter(false),
            });

            const rangeArr: string[] = ['range1', 'range2', 'range3', 'range4', 'range5'];
            rangeArr.forEach((range: string, k: number) => {
                const rangeDom: HTMLDivElement | null = document.querySelector(`.page-oasis .${range}`);
                if (rangeDom) {
                    const rangeH: number = Number(rangeDom.offsetHeight);
                    const sceneProcess = AniContainer.create({
                        triggerElement: rangeDom,
                        triggerHook: 1,
                        duration: rangeH,
                        offset: 0,
                        onEnter: () => setActive(k),
                        onProcess: (rate: number) => setProcess(100 * (1 - rate)),
                    });
                    return () => {
                        sceneProcess.destroy();
                    };
                }
            });

            return () => {
                sceneEnter.destroy();
            };
        }
    }, []);

    return (
        <div className={`fix-process ${css.section} ${enter ? 'enter' : ''}`}>
            <EfLink className={`pro-item ${active === 0 ? 'active' : ''}`} href="#page-oasis-C">
                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36" preserveAspectRatio="none">
                    <circle
                        cx="18"
                        cy="18"
                        r="16"
                        fill="#444444"
                        stroke="#FFFFFF"
                        strokeWidth="4"
                        strokeDashoffset="100"
                        strokeLinecap="round"
                        strokeDasharray="100 100"
                        style={{ strokeDashoffset: `${active === 0 ? process : INIT_PROCESS}px` }}
                    ></circle>
                </svg>
                <span className="item-name">{t('Fix_Process1')}</span>
            </EfLink>
            <EfLink className={`pro-item ${active === 1 ? 'active' : ''}`} href="#AIDriven">
                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36" preserveAspectRatio="none">
                    <circle
                        cx="18"
                        cy="18"
                        r="16"
                        fill="#444444"
                        stroke="#FFFFFF"
                        strokeWidth="3"
                        strokeDashoffset="100"
                        strokeLinecap="round"
                        strokeDasharray="100 100"
                        style={{ strokeDashoffset: `${active === 1 ? process : INIT_PROCESS}px` }}
                    ></circle>
                </svg>
                <span className="item-name">{t('Fix_Process2')}</span>
            </EfLink>
            <EfLink className={`pro-item ${active === 2 ? 'active' : ''}`} href="#SmartBackup1">
                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36" preserveAspectRatio="none">
                    <circle
                        cx="18"
                        cy="18"
                        r="16"
                        fill="#444444"
                        stroke="#FFFFFF"
                        strokeWidth="4"
                        strokeDashoffset="100"
                        strokeLinecap="round"
                        strokeDasharray="100 100"
                        style={{ strokeDashoffset: `${active === 2 ? process : INIT_PROCESS}px` }}
                    ></circle>
                </svg>
                <span className="item-name">{t('Fix_Process3')}</span>
            </EfLink>
            <EfLink className={`pro-item ${active === 3 ? 'active' : ''}`} href="#CutCosts">
                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36" preserveAspectRatio="none">
                    <circle
                        cx="18"
                        cy="18"
                        r="16"
                        fill="#444444"
                        stroke="#FFFFFF"
                        strokeWidth="4"
                        strokeDashoffset="100"
                        strokeLinecap="round"
                        strokeDasharray="100 100"
                        style={{ strokeDashoffset: `${active === 3 ? process : INIT_PROCESS}px` }}
                    ></circle>
                </svg>
                <span className="item-name">{t('Fix_Process4')}</span>
            </EfLink>
            <EfLink className={`pro-item ${active === 4 ? 'active' : ''}`} href="#Safety">
                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36" preserveAspectRatio="none">
                    <circle
                        cx="18"
                        cy="18"
                        r="16"
                        fill="#444444"
                        stroke="#FFFFFF"
                        strokeWidth="4"
                        strokeDashoffset="100"
                        strokeLinecap="round"
                        strokeDasharray="100 100"
                        style={{ strokeDashoffset: `${active === 4 ? process : INIT_PROCESS}px` }}
                    ></circle>
                </svg>
                <span className="item-name">{t('Fix_Process5')}</span>
            </EfLink>
        </div>
    );
};

export default FP;
